<template>
    <div id="wrapper">
        <app-header v-if="$route.name != 'livecenter'"></app-header>

        <div class="w1">
            <main id="main">
                <div class="container" v-if="$route.name == 'search'">
                    <search></search>
                </div>
                <div class="container" v-else-if="$route.name == 'livecenter'">
                  <cricketwidget></cricketwidget>
              </div>
                <div class="container" v-else-if="$route.name == 'aboutUs'">
                    <about-us></about-us>
                </div>

                <div class="container" v-else-if="$route.name == 'faq'">
                    <faq></faq>
                </div>

                <div class="container" v-else-if="$route.name == 'privacyPolicy'">
                    <privacy-policy></privacy-policy>
                </div>
                <div class="container" v-else-if="$route.name == 'dcma'">
                    <dcma></dcma>
                </div>
                <div class="container" v-else-if="$route.name == 'contactUs'">
                    <contactUs></contactUs>
                </div>
                <div class="container" v-else-if="$route.name == 'termsConditions'">
                    <terms-conditions></terms-conditions>
                </div>

                <div class="main-side-container container" v-else>
                    <div class="row">
                        <left-sidebar v-if="$route.name != 'newsArticle'"></left-sidebar>

                        <router-view :key="reload" />

                        <match-detail-right-sidebar v-if="$route.path.includes('/match/')"></match-detail-right-sidebar>

                        <article-right-sidebar :key="reload+'news'" v-else-if="$route.name == 'newsArticle'"></article-right-sidebar>

                        <right-sidebar v-else></right-sidebar>
                    </div>
                </div>
            </main>
            <appFooter v-if="$route.name != 'livecenter'"></appFooter>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
   // import VueAxios from 'vue-axios'
    import Faq from '../static/FAQ'
    import cricketwidget from '../livecenter/cricketwidget'
    import search from '../search/search'
    import aboutUs from '../static/AboutUs'
    import appHeader from '../common/header'
    import appFooter from '../common/footer'
    import leftSidebar from '../common/leftSidebar'
    import rightSidebar from '../common/rightSidebar'
    import PrivacyPolicy from '../static/PrivacyPolicy'

    import Dcma from '../static/Dcma'
    import contactUs from '../static/ContactUs'
    import TermsConditions from '../static/TermsConditions'
    import articleRightSidebar from '../common/articleRightSidebar'
    import matchDetailRightSidebar from '../common/matchDetailRightSidebar'
   // Vue.use(VueAxios,axios)
    export default {
        name: 'defaultLayout',

        components: {
          cricketwidget,
            Faq,
            search,
            aboutUs,
            appHeader,
            appFooter,
            leftSidebar,
            rightSidebar,
            PrivacyPolicy,
            Dcma,
            contactUs,
            TermsConditions,
		articleRightSidebar,
		matchDetailRightSidebar,
        batsman_status:'',
         against_bowlers:[],
          shot_direction:'',
        },

        data()
        {
            return {batsman:[]}
        },

        mounted()
        {

        },
        methods: {

        }
    }
</script>

<style lang="scss">
    @import '~@/assets/scss/bootstrap';
    @import '~@/assets/scss/main';
</style>